import { render } from "./DemoComposition.vue?vue&type=template&id=13286a70"
import script from "./DemoComposition.vue?vue&type=script&lang=js"
export * from "./DemoComposition.vue?vue&type=script&lang=js"
script.render = render

export default script